import { isEmpty } from '@ember/utils';
import type { JournalGroupSaveUser } from 'donor-elf-web/models/all-funds/journal-group';
import {
  validateLength,
  validatePresence,
} from 'ember-changeset-validations/validators';
import type { ValidationResult } from 'ember-changeset/types';

export default {
  name: validatePresence({ presence: true, message: 'Name is required' }),
  journalIds: validateLength({
    min: 1,
    message: 'At least one journal is required',
  }),
  users: (
    _key: string,
    newValue: JournalGroupSaveUser[] | undefined,
    _oldValue: any,
    _changes: any,
    _content: any,
  ): ValidationResult => {
    if (isEmpty(newValue)) {
      return 'At least one user is required';
    }
    if (newValue!.every((u) => !u.is_owner)) {
      return 'At leaset one user must be an owner';
    }

    return true;
  },
};
